import { render, staticRenderFns } from "./resturant_modal.vue?vue&type=template&id=49c85ab4&scoped=true&"
import script from "./resturant_modal.vue?vue&type=script&lang=js&"
export * from "./resturant_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c85ab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c85ab4')) {
      api.createRecord('49c85ab4', component.options)
    } else {
      api.reload('49c85ab4', component.options)
    }
    module.hot.accept("./resturant_modal.vue?vue&type=template&id=49c85ab4&scoped=true&", function () {
      api.rerender('49c85ab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/resturant_modal.vue"
export default component.exports